import script from "./NoticeBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeBoard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=f8eeb0d4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8eeb0d4"]])

export default __exports__